import { api } from "~/store/api";

import type {
  IGetEventMetricsByIdRequestParams,
  IGetEventMetricsByIdResponseBody,
} from "./types";

const API_PREFIX = "/events";

export const eventsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getEventMetricsById: builder.query<
      IGetEventMetricsByIdResponseBody,
      IGetEventMetricsByIdRequestParams
    >({
      query: ({ id }) => ({
        url: `${API_PREFIX}/aggregated/${id}/metrics`,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetEventMetricsByIdQuery } = eventsApi;
